/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-message[_ngcontent-%COMP%], .success-message[_ngcontent-%COMP%]{top:30px}"];
export { styles as styles };
